import { httpResource } from 'core/resources/httpResource';
import { BaseRestResource } from '@snap-alex/domain-js';
import { companyResourceUrl } from '../constants';

export class CompanyResource extends BaseRestResource {}

export const companyResource = new CompanyResource(httpResource, companyResourceUrl);
